var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.60718 14.1912H6.80968C7.33735 14.1912 7.65368 13.9567 7.75868 13.4877L9.51668 5.4137L12.5997 23.9177C12.7402 24.7612 14.0412 24.7497 14.2052 23.9177L17.1937 9.9137L17.8847 13.3937C17.9902 13.9337 18.2947 14.1912 18.8457 14.1912H23.3927C23.8617 14.1912 24.2367 13.8277 24.2367 13.3712C24.2367 12.9022 23.8732 12.5387 23.3927 12.5387H19.2442L17.8967 6.5737C17.7207 5.7652 16.5137 5.7652 16.3147 6.6087L13.3732 19.7457L10.3032 1.0777C10.1742 0.257701 8.96668 0.234201 8.77918 1.0777L6.29468 12.5387H1.60718C1.13818 12.5387 0.763184 12.9137 0.763184 13.3707C0.763184 13.8277 1.13818 14.1912 1.60718 14.1912Z",
    fill: "#1D2951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseicon);
export default __webpack_public_path__ + "static/media/pulseicon.14f7f3db477322cf12d69d47ca3060c2.svg";
export { ForwardRef as ReactComponent };